var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen bg-white pt-12 pb-12",style:({ backgroundImage: 'url(' + _vm.background + ')' })},[_c('MainHeader',{staticClass:"bg-white"}),_c('AboutSubHeader'),_c('AboutFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }